// extracted by mini-css-extract-plugin
module.exports = {"users":"Users_users__34VWU","nav":"Users_nav__3_2qK","button":"Users_button__3AXFC","active":"Users_active__3ng_H","list":"Users_list__1owrs","form":"Users_form__2OnG8"};